function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('module/Overlays',['iScroll'], function (IScroll) {
  'use strict';

  /**
   * Modal class.
   * 
   * @author Lennart Bergmann <lb@sopg.de>
   * @jira CHEF-220
   * 
   * @created 2021-02-19
   * 
   * @type Modal
   */
  var Overlays = /*#__PURE__*/function () {
    /**
     * Constructor.
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-02-19
     * @updated 2021-02-26
     * 
     * @param {$} $slide 
     * @param {string} sModalClass 
     * @param {string} sModalButton = '.open-modal' 
     * 
     * @returns {undefined}
     */
    function Overlays() {
      _classCallCheck(this, Overlays);
      this.o = {
        sel: {
          overlayWrapper: 'html',
          overlayOpener: '.js-overlay-opener',
          overlay: '.modal',
          overlayContent: '.modal-overlay',
          overlayClose: '.modal-close',
          modalContent: '.modal-content'
        },
        opt: {
          classes: {
            open: 'open',
            show: 'show',
            overlayOpen: 'overlay-open'
          }
        }
      };
      this.aIScrolls = [];
      this.init();
    }

    /**
     * Init
     * 
     * @author Lennart Bergmann <lb@sopg.de>
     * @created 2021-02-19
     * @updated 2021-03-25
     * @returns {undefined}
     */
    return _createClass(Overlays, [{
      key: "init",
      value: function init() {
        var _this = this;
        $(this.o.sel.overlayOpener).on('click', function (oEvent) {
          /* Deactivate scrolling. */
          window.fullpage.setAllowScrolling(false);
          window.fullpage.setKeyboardScrolling(false);
          oEvent.stopPropagation();
          var $overlay = $('#' + $(oEvent.target).attr('data-modal-id'));
          var $overlayContent = $overlay.find(_this.o.sel.overlayContent);
          $overlay.addClass('open');
          $overlayContent.addClass('show');
          $(_this.o.sel.overlayWrapper).addClass(_this.o.opt.classes.overlayOpen);

          /* Init scrolling. */
          if (undefined === _this.aIScrolls[$(oEvent.target).attr('data-modal-id')]) {
            var oIScroll = new IScroll($overlay.find(_this.o.sel.modalContent).get(0), {
              mouseWheel: true,
              scrollbars: true,
              scrollX: false,
              scrollY: true,
              bounce: false,
              probeType: 0
            });
            _this.aIScrolls[$(oEvent.target).attr('data-modal-id')] = oIScroll;
          }
        });
        $(this.o.sel.overlayClose).on('click', function (oEvent) {
          /* Activate scrolling. */
          window.fullpage.setAllowScrolling(true);
          window.fullpage.setKeyboardScrolling(true);
          var $overlay = $(oEvent.target).parents(_this.o.sel.overlay);
          var $overlayContent = $overlay.find(_this.o.sel.overlayContent);
          $overlay.removeClass('open');
          $overlayContent.removeClass('show');
          $(_this.o.sel.overlayWrapper).removeClass(_this.o.opt.classes.overlayOpen);
        });
        $(this.o.sel.overlay).on('click', function (oEvent) {
          /* Activate scrolling. */
          window.fullpage.setAllowScrolling(true);
          window.fullpage.setKeyboardScrolling(true);
          var $overlayContent = $(oEvent.target);
          if ($overlayContent.hasClass('modal-overlay')) {
            var $overlay = $overlayContent.parent();
            $overlay.removeClass('open');
            $overlayContent.removeClass('show');
            $(_this.o.sel.overlayWrapper).removeClass(_this.o.opt.classes.overlayOpen);
          }
        });
      }
    }]);
  }();
  return Overlays;
});

